import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { ReceiptFormTypes } from "models/formTypes";
import { ReceiptPersonContainerProps } from "models/propTypes/receiptPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import ReceiptPersonForm from "./receiptPersonForm";
//#endregion
import * as Yup from "yup";

const ReceiptPersonFormContainer: ForwardRefRenderFunction<FormHandles, ReceiptPersonContainerProps> = (props, ref) => {
  const onSubmitForm = async (values: ReceiptFormTypes.ReceiptPerson) => {
    return props.handleSubmit({ name: values.name, company: values.company } as WintSuperkollAPIModel.ReceiptPerson);
  };

  const validationSchema = Yup.object<ReceiptFormTypes.ReceiptPerson>({
    id: Yup.number(),
    name: Yup.string().required(TranslationKeys.Validations.Required),
    company: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues = {
    name: props.name,
    company: props.company,
  };

  return (
    <ReceiptPersonForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={onSubmitForm}
    />
  );
};

export default forwardRef(ReceiptPersonFormContainer);
